import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_RFID_GROUP, UPDATE_RFID_GROUP } from 'actions/rfidGroup';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';

const RfidGroupSchema = Yup.object().shape({
  name: Yup.string()
    .required('Rfid group name is required')
    .strict(true)
    .trim('Space is not allowed')
    .max(100, 'Text limit should be less than 100 characters'),
  cashback_percent: Yup.number().required('Cashback is required').min(0, 'Invalid number'),
});

const RfidGroupForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const rfidGroupDetail = useSelector((state) => state.rfidGroup.rfidGroupDetail);
  const isLoading = useSelector((state) => state.rfidGroup.isLoading);

  const addRfidGroup = useCallback((data) => {
    dispatch({
      type: CREATE_RFID_GROUP,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateRfidGroup = useCallback((data) => {
    dispatch({
      type: UPDATE_RFID_GROUP,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const initialValues = isEdit
    ? { ...rfidGroupDetail }
    : {
        name: '',
        cashback_percent: 0,
      };
  return (
    <React.Fragment>
      <div className="group-form-page__main">
        <Card>
          <div className="group-form-header__block">
            <div className="group-header-name">
              <span>{isEdit ? 'Edit' : 'Add'} Group </span>
            </div>
            <div className="close___btn">
              <MdClose size={30} color="#BE210B" onClick={onClose} />
            </div>
          </div>
          <div className="group-form-body__block">
            <div className="group-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={RfidGroupSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    const editGroupData = _.omit(values, ['tenant', 'number_of_cards']);
                    updateRfidGroup(editGroupData);
                  } else {
                    addRfidGroup(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xl={6}>
                        <TextInput
                          isRequired
                          label="Group Name"
                          placeholder="Group name"
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                      <Col xl={6}>
                        <TextInput
                          isRequired
                          label="Cashback Offer"
                          type="number"
                          placeholder="Cashback offer"
                          name="cashback_percent"
                          value={_.get(values, 'cashback_percent', '')}
                          onChange={handleChange}
                          error={errors.cashback_percent && touched.cashback_percent ? errors.cashback_percent : null}
                        />
                      </Col>
                    </Row>
                    <div className="form-btn__block">
                      {/* <Button className="form_btn cancel____btn" onClick={onClose}>
                        Cancel
                      </Button> */}
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form_btn">
                        {/* {isEdit ? 'Edit' : 'Add'} */}
                        Submit & Continue
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
RfidGroupForm.propTypes = {
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
};
export default RfidGroupForm;
